import { Component, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { StoreConfig, CookieService } from 'ngx-web-api';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { ThemeService } from '../services/theme.service';
import { Theme } from 'app/domain/theme.model';
import { Observable } from 'rxjs';

@Component({
  selector: 'fts-policy-alert',
  templateUrl: './policy-alert.component.html',
  styleUrls: ['./policy-alert.component.scss'],
})
export class PolicyAlertComponent {
  @Input()
  store: StoreConfig;
  @ViewChild('policyRef', { static: false })
  policyRef: ElementRef;
  theme$: Observable<Theme>;

  @Output() policyAcknowledged = new EventEmitter();

  public faTimes = faTimes;

  constructor(private cookieService: CookieService, public themeService: ThemeService) {
    this.theme$ = this.themeService.theme;
  }

  policyDismiss() {
    this.cookieService.setPolicyAcknowledgement();
    this.policyAcknowledged.emit();
  }
}
